<template>
  <el-dialog
    class="radish-dia"
    title="批量修改"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="radish-dia-body">
      <el-alert v-if="head.label === '组别'" type="warning" :closable="false" title="填写时以**分段"></el-alert>
      列:
      <el-select v-model="currentIndex" filterable size="mini" placeholder="选择列" @change="handleChangeHead">
        <el-option v-for="(v, k) in heads" :key="v.label + k" :label="v.label" :value="k"></el-option>
      </el-select>
      <el-select
        v-if="cates.length > 0"
        v-model="cate"
        filterable
        size="mini"
        placeholder="选择职能模块"
        @change="handleChangeCate"
      >
        <el-option v-for="(v, k) in cates" :key="k" :label="v" :value="v"></el-option>
      </el-select>
      <div v-if="head.label == '公司'" class="form-item form-item-inline" style="padding-left: 30px;">
        <label style="width: 30px;"> 值: </label>
        <el-autocomplete
          v-model="val"
          class="inline-input"
          size="mini"
          :fetch-suggestions="searchCompany"
          placeholder="值"
          :trigger-on-focus="false"
        ></el-autocomplete>
      </div>
      <div v-else-if="head.label == '部门'" class="form-item form-item-inline" style="padding-left: 30px;">
        <label style="width: 30px;"> 值: </label>
        <el-autocomplete
          v-model="val"
          class="inline-input"
          size="mini"
          :fetch-suggestions="searchDepartment"
          placeholder="值"
          :trigger-on-focus="false"
        ></el-autocomplete>
      </div>
      <template v-else>
        <formItem
          :type="head.editType"
          :is-inline="true"
          width="200"
          label-width="30px"
          display-label="值:"
          :label="head.label"
          :options="head.options"
          :content="val"
          :handle-data-change="handleChangeVal"
          :remove-tag="handleRemoveTag"
          :handle-focus="handleFocus"
        ></formItem>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'main',
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      heads: [],
      rows: [],
      cates: [],
      currentIndex: '',
      val: '',
      cate: '',
      commonVal: [],
      company: '',
    }
  },
  computed: {
    head: function() {
      if (this.currentIndex !== '') {
        return this.heads[this.currentIndex]
      } else {
        return {}
      }
    },
  },
  methods: {
    show: function(heads, rows) {
      this.currentIndex = ''
      this.val = ''
      this.cates = []
      this.cate = ''
      this.commonVal = []
      this.company = ''
      this.heads = heads.filter(h => h.editType)
      this.rows = rows
      this.dialogVisible = true
    },
    handleConfirm: function() {
      if (this.currentIndex === '') {
        return this.$message.error('请选择列')
      }
      const label = this.head.field || this.head.label
      const val = this.val
      if (!val || val.length === 0) {
        this.dialogVisible = false
        return true
      }
      if (this.head.label == '细分职能' || this.head.label == '擅长方向') {
        if (!this.cate) {
          return this.$message.error('请选择职能模块')
        }
        this.$confirm(
          `确定向已勾选行中职能模块为【${  this.cate  }】的【${  label  }】添加【${  val  }】吗?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(async () => {
            const addData = {}
            addData[label] = { $each: val }
            const ids = this.rows.map(r => r._id)
            const result = await app.service('radish').modify({
              query: { _id: { $in: ids }, 职能模块: this.cate },
              $addToSet: addData,
            })
            if (result.status == 'success') {
              this.onConfirm()
              this.dialogVisible = false
            } else {
              this.$message.error(result.msg)
            }
          })
          .catch(() => {})
      } else {
        this.$confirm(`确定修改已勾选行的【${  label  }】为【${  val  }】吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const data = {}
            data[label] = val
            const ids = this.rows.map(r => r._id)
            const result = await app.service('radish').modifyByIds({ ids: ids, data: data })
            if (result.status == 'success') {
              this.onConfirm()
              this.dialogVisible = false
            } else {
              this.$message.error(result.msg)
            }
          })
          .catch(() => {})
      }
    },
    handleChangeHead: function() {
      if (this.head.editType == 'multSelect' || this.head.editType == 'createSelect') {
        if (this.head.label == '细分职能' || this.head.label == '擅长方向') {
          let cates = []
          const commonObj = {}
          const commonVal = []
          this.rows.forEach(row => {
            // 职能模块选项
            if (row['职能模块']) {
              cates = cates.concat(row['职能模块'])
            }
            // 共有细分职能擅长方向
            if ((this.head.label == '细分职能' || this.head.label == '擅长方向') && row[this.head.label]) {
              row[this.head.label].forEach(x => {
                commonObj[x] = commonObj[x] ? commonObj[x] + 1 : 1
              })
            }
          })
          const unique = Array.from(new Set(cates))
          this.cates = unique.filter(v => v)
          if (this.head.label == '细分职能' || this.head.label == '擅长方向') {
            for (const x in commonObj) {
              if (commonObj[x] == this.rows.length) {
                commonVal.push(x)
              }
            }
            if (this.cates.length === 1) {
              this.cate = this.cates[0]
              this.handleChangeCate()
            }
            this.val = [].concat(commonVal)
            this.commonVal = commonVal
          }
        } else {
          this.val = []
        }
      } else {
        this.cates = []
        if (this.head.label == '部门') {
          const coms = this.rows.map(row => row['公司'])
          const uComs = Array.from(new Set(coms))
          // 同一公司
          if (uComs.length == 1) {
            this.company = uComs[0]
          }
        }
        this.val = ''
      }
    },
    handleChangeCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      const currentCat = catData.filter(cat => this.cate == cat['名称'])
      console.log(currentCat)
      if (this.head.label == '细分职能') {
        this.head.options = currentCat[0]['二级职能'] || []
      } else if (this.head.label == '擅长方向') {
        this.head.options = currentCat[0]['擅长方向'] || []
      }
    },
    handleChangeVal: function(res) {
      const { content } = res
      this.val = content
    },
    handleRemoveTag: function(res) {
      const { label, tag } = res
      if (this.commonVal.includes(tag)) {
        this.$confirm(`确定删除已勾选行的【${  label  }】中的【${  tag  }】吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const pullData = {}
            pullData[label] = tag
            const ids = this.rows.map(r => r._id)
            const result = await app.service('radish').modifyByIds({
              ids: ids,
              $pull: pullData,
            })
            if (result.status == 'success') {
              // this.onConfirm()
              // this.dialogVisible = false
            } else {
              this.$message.error(result.msg)
            }
          })
          .catch(e => {
            console.log(e)
            this.val.unshift(tag)
          })
        console.log('del')
      }
    },
    handleFocus: function(label) {
      if ((this.head.label == '细分职能' || this.head.label == '擅长方向') && !this.cate) {
        return this.$message.error('请先选择职能模块 啊!!!!')
      }
    },
    async searchCompany(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let results = []
      const res = await app.service('company').completeCompanyName(queryString)
      if (res.status === 'success') {
        results = res.data.map(c => ({ value: c.简称 }))
      }
      cb(results)
    },
    async searchDepartment(queryString, cb) {
      if (!queryString || !this.company) {
        cb([])
        return
      }
      let results = []
      const res = await app.service('company').completeDepartmentName({ 公司: this.company, 部门: queryString })
      if (res.status === 'success') {
        results = res.data.map(d => ({ value: d }))
      }
      cb(results)
    },
  },
}
</script>
